import { render, staticRenderFns } from "./elOptionSpan.vue?vue&type=template&id=26d676ce&scoped=true&"
import script from "./elOptionSpan.vue?vue&type=script&lang=ts&"
export * from "./elOptionSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d676ce",
  null
  
)

export default component.exports